var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedFilters)?_c('div',{class:[
		'dc-post-grid-selected-filters' ]},_vm._l((_vm.selectedFilters),function(activeFilter){return _c('button',{class:[
			'selected-filter',
			'dc-button',
			'dc-button--has-title',
			'dc-button--has-icon' ],on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeFilter(activeFilter.filter, activeFilter.value)}}},[_vm._v("\n\t\t"+_vm._s(activeFilter.label)+"\n\t")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }